import { writable } from "svelte/store";

export const locale = writable("mk");

export const error = writable(null);

export const isMobile = writable(null);
export const showSidebar = writable(true);

export const showMessage = writable(false);
export const messageObject = writable({});

export const isAuthenticated = writable(false);
export const isAdmin = writable(false);
export const isSales = writable(false);
export const salesCompanyKey = writable(null);

export const client = writable(false);

export const activePage = writable(null);
export const isLoading = writable(null);

export const searchInput = writable("");

export const cart = writable([]);
export const cartCount = writable(null);
export const cartValue = writable(null);

export const scrollToSku = writable("");

export const showReservationModal = writable(false);
